import React from "react";
import { LuImage } from "react-icons/lu";

type Props = {
  url: string | null | undefined;
  alt: string;
};

// A list's photo: the thumbnail opens the photo in a new tab, and an empty tile stands in when there is none.
const PhotoCell = ({ url, alt }: Props) =>
  url ? (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-block flex-shrink-0"
    >
      <img
        src={url}
        alt={alt}
        className="h-10 w-10 cursor-pointer rounded-md border object-cover hover:opacity-80"
      />
    </a>
  ) : (
    <div
      title="ફોટો નથી"
      className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md border border-dashed bg-gray-50"
    >
      <LuImage className="h-4 w-4 text-gray-300" />
    </div>
  );

export default PhotoCell;
